import { Allergen, DietaryRestriction } from '@sg/graphql-schema';

import { type DietaryPreferencesTypes } from './types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateInitialContext(isAllergensEnabled: boolean): Context {
  const preferences = (
    isAllergensEnabled ? INITIAL_ALLERGENS : INITIAL_DIETARY_PREFERENCES
  ) as DietaryPreferencesTypes;

  return {
    isAllergensEnabled,
    preferences,
    pendingPreferences: preferences,
    activateAfterFetch: false,
    stayActiveAfterConfirm: false,
  };
}

// ─── Constants ───────────────────────────────────────────────────────────────

export const INITIAL_ALLERGENS: Record<Allergen, boolean> = {
  [Allergen.CrustaceanShellfish]: false,
  [Allergen.Eggs]: false,
  [Allergen.Milk]: false,
  [Allergen.Peanuts]: false,
  [Allergen.Sesame]: false,
  [Allergen.Soybeans]: false,
  [Allergen.TreeNuts]: false,
  [Allergen.Wheat]: false,
  [Allergen.Fish]: false,
  [Allergen.Meat]: false,
};

export const INITIAL_DIETARY_PREFERENCES: Record<DietaryRestriction, boolean> = {
  [DietaryRestriction.Dairy]: false,
  [DietaryRestriction.Meat]: false,
  [DietaryRestriction.Nuts]: false,
  [DietaryRestriction.Gluten]: false,
  [DietaryRestriction.Fish]: false,
  [DietaryRestriction.Soy]: false,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type Context = {
  isAllergensEnabled: boolean;
  preferences: DietaryPreferencesTypes;
  pendingPreferences: DietaryPreferencesTypes;
  activateAfterFetch: boolean;
  stayActiveAfterConfirm: boolean;
};
